import ButtonComp from "components/PublicPagesReusable/ButtonComp";
import React from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
 
const ReusableHomePageSlider = ({ images = [], centerText, BottomBtns }) => {
  const pteSlider = {
    dots: true,
    arrows: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 2,
    autoplay: false,
    autoplaySpeed: 2000,
    appendDots: (dots) => {
    const maxDots = 8;
    const activeIndex = dots.findIndex(d =>
      d.props.className?.includes("slick-active")
    );

    let start = Math.max(0, activeIndex - Math.floor(maxDots / 2));
    let end = start + maxDots;

    if (end > dots.length) {
      end = dots.length;
      start = Math.max(0, end - maxDots);
    }

    const visibleDots = dots.slice(start, end);

    return <ul>{visibleDots}</ul>;
  },
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  return (
    
      <div className="our-champions-pte custom-container">
          {centerText && 
        <div className="text-center">
          {centerText()}
        </div>
          }
        <div className="pte-slider">
          <Slider {...pteSlider}>
            {images?.map((img, index) => (
              <div key={index}>
                <div className="img-wrapper">
                  <img
                    src={img.src}
                    alt={img.alt || `fame-img-${index}`}
                  />
                </div>
              </div>
            ))}
          </Slider>
        </div>
          {BottomBtns &&
            <div className="text-center" >
                <ButtonComp link={"/auth/register"} btnText={BottomBtns}/>
            </div>
          }
      </div>
  );
};

export default ReusableHomePageSlider;